import {
  BarChart as RechartsBarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
  Legend,
} from "recharts";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";

interface DataPoint {
  name: string;
  value: number;
  [key: string]: string | number;
}

interface BarChartProps {
  data: DataPoint[];
  dataKey?: string;
  xAxisKey?: string;
  title?: string;
  color?: string;
  height?: number;
  horizontal?: boolean;
}

export default function BarChart({
  data,
  dataKey = "value",
  xAxisKey = "name",
  title,
  color = "#667eea",
  height = 300,
  horizontal = false,
}: BarChartProps) {
  const layout = horizontal ? "vertical" : "horizontal";

  return (
    <Card>
      {title && (
        <CardHeader>
          <CardTitle>{title}</CardTitle>
        </CardHeader>
      )}
      <CardContent>
        <ResponsiveContainer width="100%" height={height}>
          <RechartsBarChart
            data={data}
            layout={layout}
            margin={{
              top: 5,
              right: 30,
              left: horizontal ? 100 : 20,
              bottom: 5,
            }}
          >
            <CartesianGrid strokeDasharray="3 3" className="stroke-muted" />
            {horizontal ? (
              <>
                <XAxis
                  type="number"
                  className="text-xs fill-muted-foreground"
                />
                <YAxis
                  type="category"
                  dataKey={xAxisKey}
                  className="text-xs fill-muted-foreground"
                  width={90}
                />
              </>
            ) : (
              <>
                <XAxis
                  dataKey={xAxisKey}
                  className="text-xs fill-muted-foreground"
                />
                <YAxis className="text-xs fill-muted-foreground" />
              </>
            )}
            <Tooltip
              contentStyle={{
                backgroundColor: "hsl(var(--card))",
                border: "1px solid hsl(var(--border))",
                borderRadius: "8px",
              }}
              formatter={(value: number) => [value.toLocaleString(), "Count"]}
            />
            <Legend />
            <Bar dataKey={dataKey} fill={color} radius={[4, 4, 0, 0]} />
          </RechartsBarChart>
        </ResponsiveContainer>
      </CardContent>
    </Card>
  );
}
